export default "__VITE_ASSET__DTpjuXy$__"